import actions from 'src/modules/event/demote/eventDemoteActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.DEMOTE_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.DEMOTE_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.DEMOTE_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.DEMOTE_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.DEMOTE_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.DEMOTE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};
